<template>
  <div>
    <div v-show="!File">
      <vue-dropzone
        id="drop1"
        :options="dropzoneOptions"
        :useCustomSlot="true"
        @vdropzone-file-added="getFile"
        ref="myVueDropzone"
      >
        <div class="dropzone-custom-content">
          <h3 class="dropzone-custom-title">Arrastra y suelta el JSON aquí para procesarlo!</h3>
          <div class="subtitle">...o click para seleccionarlo desde de tu computador</div>
        </div>
      </vue-dropzone>
    </div>
    <div v-show="File">
      <v-row>
        <!-- <v-col class="pb-0" cols="12" style="text-align: center;">
          <img width="180px;" src="@/assets/img/excel.png" style="margin:0 auto;" />
        </v-col>-->
        <v-col cols="12">
          <p class="mb-0" v-if="File" style="font-size:18pt;text-align:center">{{File.name}}</p>
        </v-col>
        <!-- <v-col cols="12" style="text-align: center;">
          <v-btn @click="processFile()" large color="primary">
            <v-icon left>mdi-upload-outline</v-icon>Procesar Archivo
          </v-btn>
        </v-col> -->
      </v-row>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "Dropzone",
  components: {
    vueDropzone: vue2Dropzone
  },
  data: () => ({
    params: null,
    dropzoneOptions: {
      url: "prueba",
      maxFilesize: 2,
      maxFiles: 1,
      autoProcessQueue: false,
      acceptedFiles: ".json"
    },
    File: null,
    loading: false,
    snackbarParams: false
  }),
  methods: {
    getFile(file) {
      let vm = this;
      if (file) {
        var reader = new FileReader();
        reader.onloadend = function() {
          const data = reader.result;
          let json = JSON.parse(data);
          vm.$emit("processedFile", json);
        };

        reader.readAsText(file);
      }
    }
  }
};
</script>
